export default (method, callback) => (dispatch, getState) => {

  const { token, clientEmail, clientPdf }  = getState()

  if(method === 'GET'){
    fetch(`${process.env.REACT_APP_API_URL}/image/logo/${clientEmail}/`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token &&
          `Token ${token}`,
      },
    })
    .then(d => {
      if(d.status === 404){
        return;
      } else {
        return d.blob();
      }
    })
    .then(image => {
      if(image){
        var reader = new FileReader()
        reader.onload = e => {
          dispatch({ type: 'SET_CLIENT_PDF', key: 'savedLogo', value: e.target.result })
          dispatch({ type: 'SET_CLIENT_PDF', key: 'logoKey', value: 'savedLogo' })
        }
        reader.readAsDataURL(image)
      }
    })
    .catch(error => {
      console.error(error);
    });
  } else if (method === 'POST') {
    if (clientPdf.logoKey !== 'clientLogo') {
      callback && callback()
      return // POST unnecessary if logo is already saved in the db
    }

    const form = new FormData()
    form.append('clientEmail', clientEmail)
    form.append('fileName', 'clientLogo.png')

    let data = clientPdf.clientLogo.split(",")
    if(data.length > 1){
      let array = []
      try {
        const binary = window.atob(data[1])
        for(let i = 0; i < binary.length; i++){
          array.push(binary.charCodeAt(i))
        }
      } catch(e) {
        console.log(e)
      }
      form.append('imageData', new Blob([new Uint8Array(array)], { type: 'image/png' }))
    } else {
      form.append('imageURL', data[0])
    }

    fetch(`${process.env.REACT_APP_API_URL}/image/logo/`, {
      method: 'POST',
      body: form,
      headers: {
        Authorization: token &&
          `Token ${token}`,
      },
      "contentType": false,
      "mimeType": "multipart/form-data",
    })
    .then(d => d.json())
    .then(data => {
      callback && callback()
    })
    .catch(error => {
      console.error(error);
    });
  }

};


// WEBPACK FOOTER //
// ./src/actions/query-api/logo-store.js